import { render, staticRenderFns } from "./ReseauxSociaux.vue?vue&type=template&id=45cc0e62&scoped=true&"
var script = {}
import style0 from "./ReseauxSociaux.vue?vue&type=style&index=0&id=45cc0e62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45cc0e62",
  null
  
)

export default component.exports